import { RootState } from "@/sharedStore/store";

export const scheduleListSelector = (state: RootState) =>
  state.scheduleSlice.scheduleList;

export const scheduleListLoading = (state: RootState) =>
  state.deliverySlice.loading;
export const scheduleListLoaded = (state: RootState) =>
  state.deliverySlice.loaded;
